import React from "react";

// ASSETS
import LogoDsu from "assets/svg/LogoDsu.svg";

// STYLES
import {
  HeaderContainer,
  Logo,
  LogoTextContainer,
  LogoContainer, LogoText,
} from "./HeaderMobileStyled";

// LIBRARIES
import { useNavigate } from "react-router-dom";

// MISC
import { IProps } from "./HeaderMobileModel";

// REDUX
import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// COMPONENTS
import MobileHeaderAtom from "components/Atoms/MobileHeaderAtom/MobileHeaderAtom";

const Header = (props: IProps) => {
  // PROPERTIES
  const { handleScrollToTop } = props;
  // LIBRARY CONSTANTS
  const navigate = useNavigate();
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);

  // STATE CONSTANTS

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS
  const goToHomePage = () => {
    navigate("/");
    handleScrollToTop();
  };
  return (
    <HeaderContainer $hasSectionNavigation={props.hasSectionNavigation}>
      <LogoContainer onClick={goToHomePage} biggerCursor={biggerCursor}>
        <Logo src={LogoDsu} alt="Logo" biggerCursor={biggerCursor} />
        <LogoTextContainer biggerCursor={biggerCursor}>
          <LogoText>{"Departamentul pentru\n" +
            "Situații de Urgență"}</LogoText>
        </LogoTextContainer>
      </LogoContainer>
      <MobileHeaderAtom />
    </HeaderContainer>
  );
};

export default Header;
